import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import Card from "../../UI/Card/CardDashboard";
import Widget from "../../UI/Widget/Widget";

import ApplicationsList from "../Applications/ApplicationsList";
import Headline from "../../Headline/Headline";
import EmptyState from "../../UI/State/EmptyState";
import ActionState from "../../UI/State/ActionState";
import Channel from "../Channel/Channel";

import * as BillingUtils from "../../Utils/BillingUtils";
import * as ContactUtils from "../../Utils/ContactUtils";
import * as DeveloperUtils from "../../Utils/DeveloperUtils";
import * as ApplicationsUtils from "../../Utils/ApplicationsUtils";
import * as GlobalConstant from "../../Constants/GlobalConstant";
import * as ChannelUtils from "../../Utils/ChannelUtils";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRocket, faBox, faChartLine, faPlusCircle, faNewspaper, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import { faCreditCard } from "@fortawesome/free-regular-svg-icons";

import { RegisterHashTag, OptionHashTag } from "../Profile/Profile";

import LogService from "../../../middleware/CommonSdk/LogService";
const LOG_TAG = "DASHBOARD";

const Dashboard = (props) => {
    const intl = useIntl();

    useEffect(() => {
        LogService.trace(LOG_TAG, "use effect didmount")
        window.scrollTo(0, 0);
    }, []);

    LogService.trace(LOG_TAG, "render");
    const displayName = ContactUtils.getDisplayName(props.user);
    const title = intl.formatMessage({ id: "dashboardTitle" }, { name: displayName });
    const subtitle = intl.messages.dashboardMessage;//intl.formatMessage({ id: "newNotification" }, { value: 3 });
    
    const applicationsCount = props.applications ? props.applications.length : 0;
    let applicationDisplay =
        <ActionState
            icon={faPlusCircle}
            text={intl.messages.applicationCreateButton}
            className="state-blue"
            to={GlobalConstant.APPLICATION_PATH + GlobalConstant.CREATE_PATH}
        />;

    if (props.applicationsProgress) {
        applicationDisplay = <EmptyState progress={true} text="" />;
    } else if (applicationsCount > 0) {
        applicationDisplay = <ApplicationsList isSummary={true} isMaxSize={props.isChannelSubscribed} />;
    } 

    let widgetCards = [];
    let cards = [];
    if (props.isChannelSubscribed) {
        /* Channel Card */
        cards.push(
            <div key="card_0" className="d-flex col-lg-6">
                <Channel />
            </div>
        );
    } else {
        cards.push(
            <div key="card_4" className="d-flex col-lg-6">
                <Card
                    title={intl.messages.dashboardChannelTitle}
                    subtitle={intl.messages.dashboardChannelSubTitle}
                    icon={faNewspaper}
                    label={intl.messages.gotoProfilePage}
                    to={GlobalConstant.PROFILE_PATH + "#" + OptionHashTag}
                    bgColor="bg-violet"
                >
                    <div className="state bordered py-3 state-purple text-left">
                        <div className="px-3">
                            <p>{intl.messages.dashboardChannelMessage}</p>
                            <p>{intl.formatMessage({ id: "dashboardChannelMessageUnsubscribe"}, { b: chunks => <b>{chunks}</b> })}</p>
                            <p>{intl.messages.dashboardChannelMessageSubscribe}</p>

                            <Link to={GlobalConstant.PROFILE_PATH + "#" + OptionHashTag} className="btn btn-link">
                                <FontAwesomeIcon icon={faArrowRight} className="mr-2 text-violet" />
                                {intl.messages.startNow}
                            </Link>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }

    if (props.isDeveloper) {
        widgetCards.push(
            <div key="widget_0" className="d-flex col-xs-12 col-md-6 col-xl-3">
                <Widget number={applicationsCount.toString()} label={intl.messages.applicationsCreatedMessage} icon={faRocket} className="text-blue" colorIcon="blue" to={GlobalConstant.APPLICATIONS_PATH} progress={props.applicationsProgress} />
            </div>
        );
        widgetCards.push(
            <div key="widget_1" className="d-flex col-xs-12 col-md-6 col-xl-3">
                <Widget number={props.hasPaymentMethod ? "Yes" : "No"} label={intl.messages.billingMethods} icon={faCreditCard} className="text-pink" colorIcon="pink" to={GlobalConstant.BILLING_PATH} />
            </div>
        );
        widgetCards.push(
            <div key="widget_2" className="d-flex col-xs-12 col-md-6 col-xl-3">
                <Widget number={props.hasSandboxAccount ? "Yes" : "No"} label={intl.messages.sandboxMethods} icon={faBox} className="text-green" colorIcon="green" to={GlobalConstant.SANDBOX_PATH} />
            </div>
        );
        widgetCards.push(
            <div key="widget_3" className="d-flex col-xs-12 col-md-6 col-xl-3">
                <Widget number={props.myDeployedApplications.length.toString()} label={intl.messages.deploymentMethods} icon={faChartLine} className="text-orange" colorIcon="orange" to={GlobalConstant.APPLICATIONS_PATH} progress={props.applicationsProgress}/>
            </div>
        );

        /* Application Card */
        cards.push(
            <div key="card_1" className="d-flex col-lg-6">
                <Card
                    title={intl.messages.applicationsTitle}
                    subtitle={intl.messages.applicationsMessage}
                    icon={faRocket}
                    label={intl.messages.gotoApplicationPage}
                    to={GlobalConstant.APPLICATIONS_PATH}
                    bgColor="bg-blue"
                >
                    {applicationDisplay}
                </Card>
            </div>
        );

        if (!props.hasPaymentMethod) {
            /* Billing Card */
            cards.push(
                <div key="card_2" className="d-flex col-lg-6">
                    <Card
                        title={intl.messages.billingTitle}
                        subtitle={intl.messages.billingMessage}
                        icon={faCreditCard}
                        label={intl.messages.gotoBillingPage}
                        to={GlobalConstant.BILLING_PATH}
                        bgColor="bg-pink"
                    >
                        <ActionState icon={faPlusCircle}
                            text={intl.messages.addBilling}
                            //desc={intl.messages.addBillingMessage}
                            className="state-pink"
                            to={GlobalConstant.BILLING_PATH}
                        />
                    </Card>
                </div>
            );
        }

        if (!props.hasSandboxAccount) {
            /* SandBox Card */
            cards.push(
                <div key="card_3" className="d-flex col-lg-6">
                    <Card
                        title={intl.messages.sandBoxTitle}
                        subtitle={intl.messages.sandBoxDashboardMessage}
                        icon={faBox}
                        label={intl.messages.gotoSandBoxPage}
                        to={GlobalConstant.SANDBOX_PATH}
                        bgColor="bg-green"
                    >
                        <ActionState icon={faPlusCircle}
                            text={intl.messages.sandBoxAddAccountMessage}
                            className="state-green"
                            to={GlobalConstant.SANDBOX_PATH}
                        />
                    </Card>
                </div>
            );
        }       

    } else if (props.isSuperAdminOrAppSuperAdmin || props.isSupportOrAppSupport) {
        widgetCards.push(
            <div key="widget_0" className="d-flex col">
                <Widget number={applicationsCount.toString()} label={intl.messages.applicationsCreatedMessage} icon={faRocket} className="text-blue" colorIcon="blue" to={GlobalConstant.APPLICATIONS_PATH} progress={props.applicationsProgress} />
            </div>
        );
        widgetCards.push(
            <div key="widget_1" className="d-flex col">
                <Widget number={props.myDeployedApplications.length.toString()} label={intl.messages.deploymentMethods} icon={faChartLine} className="text-orange" colorIcon="orange" to={GlobalConstant.APPLICATIONS_PATH} progress={props.applicationsProgress} />
            </div>
        );

        /* Application Card */
        cards.push(
            <div key="card_1" className="d-flex col-lg-6">
                <Card
                    title={intl.messages.applicationsTitle}
                    subtitle={intl.messages.applicationsMessage}
                    icon={faRocket}
                    label={intl.messages.gotoApplicationPage}
                    to={GlobalConstant.APPLICATIONS_PATH}
                    bgColor="bg-blue"
                    extented={true}
                >
                    {applicationDisplay}
                </Card>
            </div>
        );

        /* Statistics Card */
        // cards.push(
        //     <div key="card_2" className="d-flex col-lg-6">
        //         <Card
        //             title={intl.messages.applicationStatisticsTitle}
        //             subtitle={intl.messages.applicationStatisticsSubTitle}
        //             icon={faChartBar}
        //         >
        //             <EmptyState icon={faChartBar} text={intl.messages.noStatistics} desc="nimia in peiores haeserat plagas" />
        //         </Card>
        //     </div>
        // );
    } else {//user
        widgetCards.push(
            <div key="widget_0" className="col">
                <div className="card">
                <div className="card-text" style={{ whiteSpace: "pre-line" }}>    
                    {intl.formatMessage({ id: "dashboardRegisterWelcomeMessage" }, { link: <Link to={GlobalConstant.PROFILE_PATH + "#" + RegisterHashTag} >{intl.messages.settingsRegisterTitle}</Link>, b: chunks => <b>{chunks}</b> })}
                    </div> 
                </div>
            </div>
        );
    }

    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />
            <div className="row">
                {widgetCards}
            </div>

            <div className="row">
                {cards}
            </div>
        </div>
    );
}

Dashboard.defaultProps = {
    hasPaymentMethod: false,
    hasSandBoxAccount: false,
}

Dashboard.propTypes = {
    user: PropTypes.object,
    isChannelSubscribed: PropTypes.bool
}

const mapStateToProps = state => {
    return {
        user: state.contacts.user,
        isChannelSubscribed: ChannelUtils.isSubscribed(state.channel),
        applications: ApplicationsUtils.myApplications(state.applications.applications, state.contacts.user),
        applicationsProgress: state.applications.progress,
        myDeployedApplications: ApplicationsUtils.myDeployedApplications(state.applications.applications, state.contacts.user),
        hasPaymentMethod: BillingUtils.hasPaymentMethod(state.payments),
        hasSandboxAccount: DeveloperUtils.hasSandboxAccount(state.contacts.user),
        isDeveloper: ContactUtils.isDeveloper(state.contacts.user),
        isSuperAdminOrAppSuperAdmin: ContactUtils.isSuperAdminOrAppSuperAdmin(state.contacts.user),
        isSupportOrAppSupport: ContactUtils.isSupportOrAppSupport(state.contacts.user),
    };
};

export default connect(mapStateToProps)(Dashboard);